// These are Statsig experiments
export const MACRO_INTERACTION_DESIGN_UPDATES = 'confluence_frontend_macro_interaction_design';
export const MACRO_INTERACTION_BUTTON_UPDATES = 'confluence_live_macros_config_button_updates';
